<template>
  <div class="row primary-filter" v-if="!loading">
    <div class="col-md-auto filter-grid">
      <ul class="inlinelist">
        <li class="app-side-menu">
          <span @click="openMenu" class="pointer">
              <svgicon name="menu" width="20" height="20" :original="true" class="menu" />
              </span>
          <div class="sidemenu-slideout" :class="{ isOpen: isOpen }">
            <Sidebar v-on:close="onCloseMenu" />
          </div>
        </li>
        <li class="color-changes category">
          <FilterDropdown v-if="seletedMainStatus"
                          :options="statusList"
                          :selected="seletedMainStatus"
                          v-on:updateOption="onChangeFilter" />
        </li>
      </ul>
    </div>
    <div class="col filter-grid">
      <div class="row">
        <div class="col">
          <div class="app-search-label">
            <svgicon name="search" width="18" height="18" :original="true" />
            <span class="">
          <input placeholder="Search by reference no" v-on:keyup="search" v-model="query">
        </span>
          </div>
        </div>
        <div class="col-md-auto">
            <InvoiceSearch subFilterTitle="Filter by Type"
                           :filterList="subStatus"
                           :subFilterList="subFilterList"
                           :searchBy = "searchBy"
                           :selectedStatus="filter.status"
                           :selectedSubFilter="constructSubFilter"
                           :selectedSearchBy="constructSearchFilter"
                           :hideDatePicker="hideDatePicker"
                           :hideExportAll="showVoucherView"
                           @searchTermChange="searchTermChange"
                           @filterChange="filterChange"
                           @subFilterChange="subFilterChange"
                           @dateChange ="dateChange"
                           @exportAllInvoice="$emit('exportAllInvoice')"/>
        </div>
      </div>
    </div>
    <div class="col-md-auto filter-grid filter-button">
      <ul class="filter-btn-group inlinelist">
       <li v-if="seletedMainStatus.id === 1">
        <div class="action_dropdown" v-click-outside="closeExportDropdown">
          <div :class="{checked:openDropdown}">
            <label for="toggle_nav" id="action_color" class="btn btn-secondary" @click="toggleexportDropDown(true)">
              Export
            </label>
          </div>
          <div id="inlabel" d @click="toggleexportDropDown(true)">
            <div :class="{checked:openDropdown}">
              <span class="action_dropdown_arrow_image"></span>
            </div>
          </div>
          <ul class="action_dropdown_options list-unstyled" v-if="openDropdown">
            <li class="select_options" v-if="$invoice.showExport() && $hasPermission('invoice_export')">
              <a href="#" @click="$emit('exportInvoice', 'Invoice')">Export</a>
            </li>
            <li class="select_options" v-if="$invoice.showExport() && $hasPermission('invoice_export')">
              <a href="#" @click="$emit('exportAllInvoice', 'Invoice')"> Export All</a>
            </li>
          </ul>
        </div>
      </li>

        <li v-if="$hasFeature('invoice_voucher') && $hasPermission('invoice_generate_voucher')">
          <button class="btn btn-primary"
                  :class="{ 'greyOut': disableButton }"
                  :disabled="disableButton"
                  v-if="$invoice.showGenerateVoucher()"
                  @click="$emit('voucher')">
              Generate Voucher
      </button>
        </li>
        <li v-if="$invoice.showHoldApprove()">
          <button class="btn btn-primary"
                  :class="{ 'greyOut': disableButton }"
                  :disabled="disableButton"
                  @click="$emit('reApprove')">
                  Re Approve
          </button>
        </li>
        <li v-if="$invoice.showVerify($hasFeature('invoice_voucher'))">
          <button class="btn btn-secondary"
                  :class="{ 'greyOut': disableButton }"
                  :disabled="disableButton"
                  @click="$emit('reject', 'librarian')">
                  Hold
         </button>
        </li>

        <li v-if="$invoice.showVerify($hasFeature('invoice_voucher'))">
        <button class="btn btn-primary"
                :class="{ 'greyOut': disableButton }"
                :disabled="disableButton"
                @click="$emit('approve', 'librarian')">
               Verify
        </button>
      </li>

        <li v-if="$invoice.showPaid() && $invoice.hideVoucherActions()">
          <button class="btn btn-primary"
                  :class="{ 'greyOut': disableButton }"
                  :disabled="disableButton"
                  @click="$emit('approve', 'accountant')">
                  Paid
          </button>
          <!-- <button class="btn btn-secondary"
                  :class="{ 'greyOut': disableButton }"
                  :disabled="disableButton"
                  @click="$emit('reject', 'accountant')">
                  Reject
          </button> -->
        </li>
        <li v-if="$invoice.showMiroExport(seletedMainStatus, $hasFeature('invoice_voucher')) && $hasPermission('miro_download') && $invoice.hideVoucherActions()">
          <button class="btn btn-primary"
                  :class="{ 'greyOut': disableButton }"
                  :disabled="disableButton"
                  @click="$emit('exportInvoice', 'Miro')">
                  Miro
          </button>
        </li>
        <li v-if="$invoice.showVoucherExport() && $invoice.hideVoucherActions()">
          <button class="btn btn-primary"
                  :class="{ 'greyOut': disableButton }"
                  :disabled="disableButton"
                  @click="$emit('exportInvoice', 'Miro')">
                  Export
          </button>
        </li>
        <li v-if="$invoice.showMiroImport() && rejectedCount">
          <button class="btn btn-primary" @click="$emit('rejectDownload')">
                  Rejected
         </button>
        </li>
        <!-- <li v-if="$invoice.showMiroImport()">
          <a href="https://d1yehklgqjav7t.cloudfront.net/static/sample/paymentStatusUpload.xlsx" download
          class="btn btn-secondary" target="_blank">
           Sample Format
           </a>
        </li>
        <li v-if="$invoice.showMiroImport()">
          <label v-if="!inXLSProgress">
          <input class="upload-material" type="file" id="file" ref="file"
          v-on:change="handleFileUpload"/>
            <span class="action btn btn-primary">Upload</span>
        </label>
        <Processing v-if="inXLSProgress" background="#0073FF" size="30px" />
        </li> -->
        <li v-if="$invoice.showMiroImport() && $invoice.hideVoucherActions()">
          <Processing v-if="inXLSProgress" background="#0073FF" size="30px" />
          <Dropdown v-if="!inXLSProgress" trigger="click" :class="{dropdownbutton : dropdownOpen}">
            <button type="primary" class="btn btn-secondary" @click="dropdownOpen = !dropdownOpen">
                  UPLOAD
                  <svgicon name="categorydropdown"
                  class="dropdown-icon"
                  width="10" height="10"
                  :original="true" />
                </button>
            <Dropdown-menu slot="dropdown">
              <Dropdown-item>
                <label>
                    <input class="upload-material" type="file" id="file" ref="file" :accept="`${AttachmentConstants.excelMimes}`"
                    v-on:change="handleFileUpload"/>
                      <span class="action">Bulk Upload</span>
                  </label>
                <a :href="`${$asset_path}static/sample/${sampleFileName}`"
                  v-if="sampleFileName.length" download
                   class="format-text"
                   target="_blank">
                    <span class="divided"></span>
                    Sample format</a>
              </Dropdown-item>
            </Dropdown-menu>
          </Dropdown>
        </li>
      </ul>
    </div>
  </div>

</template>
<script>
import debounce from 'debounce';
import Sidebar from '@/components/common/Sidebar';
import InvoiceSearch from '@/components/common/app-search';
import FilterDropdown from '@common/components/FilterDropdown';
import AttachmentConstants from '@common/constants/AttachmentConstants';

export default {
  components: {
    Sidebar,
    FilterDropdown,
    InvoiceSearch,
  },
  props: {
    placeholder: {
      type: String,
    },
    title: {
      type: String,
      default: '',
    },
    sampleFileName: {
      type: String,
      default: '',
    },
    resetSearch: {
      type: Boolean,
      default: true,
    },
    statusList: {
      type: Array,
      default() {
        return [];
      },
    },
    filter: {
      type: Object,
    },
    selectedInvoices: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    inXLSProgress: {
      type: Boolean,
      default: false,
    },
    rejectedCount: {
      type: Number,
      default: 0,
    },
    showVoucherView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      s3URL: process.env.VUE_APP_S3_PATH,
      isOpen: false,
      query: null,
      hideDatePicker: true,
      gstType: [{ id: 1, name: 'FCM', type: 'gst_type' }, { id: 2, name: 'RCM', type: 'gst_type' }],
      searchTerm: [{ label: 'Transporter', id: 'transporter_name', query: null }],
      dropdownOpen: false,
      openDropdown: false,
      AttachmentConstants,
    };
  },
  created() {
    this.query = this.filter.reference_number;
  },
  computed: {
    seletedMainStatus() {
      const fetchStatus = this.statusList.find(access => access.id === this.filter.mainStatus);
      return fetchStatus;
    },
    subStatus() {
      return this.seletedMainStatus ? this.seletedMainStatus.subFilter : [];
    },
    disableButton() {
      return !this.selectedInvoices;
    },
    searchBy() {
      const searchTermList = [...this.searchTerm];

      if (this.filter.mainStatus === 1) {
        searchTermList.push({ label: 'Lr number', id: 'lr_number', query: null });
        searchTermList.push({ label: 'Indent Id', id: 'indent_id', query: null });
      }
      if (this.filter.mainStatus === 2) {
        searchTermList.push({ label: 'Invoice Number', id: 'invoice_number', query: null });
      }
      return searchTermList;
    },
    subFilterList() {
      const subStatus = [...this.gstType];
      if (this.filter.mainStatus === 2) {
        const temp = [
          { id: 1, name: 'Credit Note', type: 'note_type' },
          { id: 2, name: 'Debit Note', type: 'note_type' },
        ];
        subStatus.push(...temp);
      }
      return subStatus;
    },
    constructSearchFilter() {
      const result = {};
      if (this.filter.transporter_name) {
        result.transporter_name = this.filter.transporter_name;
      } else if (this.filter.lr_number) {
        result.lr_number = this.filter.lr_number;
      } else if (this.filter.indent_id) {
        result.indent_id = this.filter.indent_id;
      } else {
        result.invoice_number = this.filter.invoice_number;
      }
      return result;
    },
    constructSubFilter() {
      const result = {};
      if (this.filter.gst_type) {
        result.gst_type = this.filter.gst_type;
      } else if (this.filter.note_type) {
        result.note_type = this.filter.note_type;
      }
      return result;
    },
  },
  methods: {
    toggleexportDropDown(value) {
      this.openDropdown = !this.openDropdown;
    },
    closeExportDropdown() {
      this.openDropdown = false;
    },
    search: debounce(function debounceSearch() {
      const query = this.query;
      this.$emit('search', query);
    }, 500),
    onChangeFilter(data) {
      this.seletedSubOption = data;
      this.$emit('changeMainStatus', data.id);
      const [firstStatus] = this.subStatus;
      this.filterChange(firstStatus.id);
    },
    filterChange(Id) {
      if (Id) {
        this.$emit('changeStatus', Id);
      }
    },
    subFilterChange(data) {
      this.$emit('changeType', data);
    },
    searchTermChange(data) {
      this.$emit('changeSearchTerm', data);
    },
    dateChange(date) {
      this.$emit('changeDateRange', date);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.$emit('bulkUpload', this.file);
      // Reset the uploaded file value
      const input = this.$refs.file;
      input.type = 'text';
      input.type = 'file';
    },
    onCloseMenu() {
      this.isOpen = false;
    },
    openMenu: function open() {
      this.isOpen = true;
    },
  },
};

</script>

<style scoped lang="scss">
.action_dropdown {
  width: max-content;
  position: relative;
  .checked{
    label{
      background-color:#e3effa;
      border-bottom-left-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  label{
    display: block;
    cursor: pointer;
    margin-bottom: 0px;
    width: 110px;
  }
  #inlabel{
    position: absolute;
    top: 10px;
    right: 12px;
    .checked{
      .action_dropdown_arrow_image{
      width: 8px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      float: right;
      margin-right: 0px;
      height: 8px;
      border-bottom: 2px solid #008AFF;
      border-left: 2px solid #008AFF;
      -webkit-transform: rotateZ(135deg);
      transform: rotateZ(135deg);
      top: 4px;
      position: relative;
      right: 12px;
      }
    }
    .action_dropdown_arrow_image{
      width: 8px;
      -webkit-transition: all 0.5s;
      transition: all 0.5s;
      float: right;
      margin-right: 0px;
      height: 8px;
      border-bottom: 2px solid 	#008AFF;
      border-left: 2px solid #008AFF;
      -webkit-transform: rotateZ(-45deg);
      transform: rotateZ(-45deg);
      position: relative;
      right: 12px;
    }
  }
  ul{
      margin-bottom: 0px;
      margin-top: 0px;
      position: absolute;
      width: 110px;
      border-right: 1px solid #EEF2F4;
      border-left: 1px solid #EEF2F4;
      border-bottom: 1px solid #EEF2F4;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      background: #fff;
      padding: 0 8px;
  }
  &_options{
    .select_options{
      text-align: left;
      border-bottom: 1px solid #EEF2F4;
      padding: 10px 5px;
      font-size: 12px;
      text-transform: uppercase;
      width: 100%;
      margin: 0px !important;
      font-weight: normal;
      &:last-child{
        border-bottom: 1px solid transparent;
      }
      a{
        font-size: 1.2rem;
        color: #008aff;
        text-transform: capitalize;
        text-decoration: none;
      }
    }
  }
}
</style>
